import { useEffect, useRef } from "react";

const benefits = [
  {
    icon: "ri-database-2-line",
    title: "Tysiące produktów",
    desc: "Gotowe zestawienia najlepszych produktów z Chin. Nie szukaj godzinami — wszystko masz w jednym miejscu.",
    color: "bg-primary-500",
  },
  {
    icon: "ri-time-line",
    title: "Oszczędność czasu",
    desc: "Nie szukaj godzinami — korzystaj z gotowych linków i sprawdzonych produktów. Kupuj szybciej i mądrzej.",
    color: "bg-accent-500",
  },
  {
    icon: "ri-bar-chart-box-line",
    title: "Porównania produktów",
    desc: "Tabela cen, jakości i popularności. Porównuj produkty i wybieraj najlepsze oferty dla siebie.",
    color: "bg-secondary-500",
  },
  {
    icon: "ri-shield-check-line",
    title: "Bezpieczne zakupy",
    desc: "Dowiedz się jak unikać błędów, sprawdzać sprzedawców i robić bezpieczne zakupy na Kakobuy.",
    color: "bg-primary-500",
  },
];

export default function BenefitsSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.15 }
    );

    const els = sectionRef.current?.querySelectorAll(".reveal-card");
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Dlaczego Kakobuy Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Odkryj zalety korzystania z naszej bazy produktów i przewodnika zakupowego
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {benefits.map((b, i) => (
            <div
              key={b.title}
              className="reveal-card opacity-0 translate-y-8 transition-all duration-700 ease-out bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 hover:border-primary-300/40 hover:shadow-md transition-all"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${b.color} text-background-50 mb-4`}>
                <i className={`${b.icon} text-xl`} />
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-2">
                {b.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {b.desc}
              </p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .reveal-card.animate-in {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}